import queryString from 'query-string';
import typeCheck from 'common/util/typeCheck';

import {
  PARTNER_AGENT_SIGNUP_TYPE_OTHER,
  PARTNER_AGENT_SIGNUP_TYPE_LISTING_AGENT,
  PARTNER_AGENT_SIGNUP_TYPE_TENANT_SCREENING,
  PARTNER_AGENT_SIGNUP_TYPE_SUNRISE,
  PARTNER_SIGNUP_TYPE_SUN_SCREEN,
  PARTNER_SIGNUP_TYPE_SUN_RISE,
  PARTNER_SIGNUP_TYPE_FULL_SERVICE,
  PARTNER_BILLING_PLAN_SAAS,
} from 'common/partnerConstants';

export function getPartnerListingUrlPath(partner, listing, queryParams) {
  typeCheck('partner::NonEmptyObject', partner);
  typeCheck('listing::NonEmptyObject', listing);
  typeCheck('queryParams::Maybe Object', queryParams);

  let querySearch = queryParams ? `?${queryString.stringify(queryParams)}` : '';
  if (querySearch === '?') {
    querySearch = '';
  }

  return `/partner/${partner.slug}/listing/${listing.id}${querySearch}`;
}

export function makeOwnerMarketingPageUrl(partner, appUrl) {
  typeCheck('partner::NonEmptyObject', partner);
  typeCheck('appUrl::NonEmptyString', appUrl);
  return `${appUrl}/m/${partner.id}/${partner.displayName.toLowerCase().replace(/\s/g, '')}`;
}

export function tenantScreeningEnabled(partner) {
  typeCheck('partner::NonEmptyObject', partner);
  return partner.agentSignupReasonType === PARTNER_AGENT_SIGNUP_TYPE_TENANT_SCREENING;
}

export function sunRiseEnabled(partner) {
  typeCheck('partner::NonEmptyObject', partner);
  return partner.agentSignupReasonType === PARTNER_AGENT_SIGNUP_TYPE_SUNRISE;
}

export function isSaasPartner(partner) {
  typeCheck('partner::NonEmptyObject', partner);
  return partner.billingPlan === PARTNER_BILLING_PLAN_SAAS;
}

export function getSunroomUtilityPortalUrl(partner) {
  typeCheck('partner::NonEmptyObject', partner);
  return `/utility-profit/${partner.slug}`;
}

export function getPartnerSignupType(partner) {
  typeCheck('partner::NonEmptyObject', partner);

  switch (partner.agentSignupReasonType) {
    case PARTNER_AGENT_SIGNUP_TYPE_TENANT_SCREENING:
      return PARTNER_SIGNUP_TYPE_SUN_SCREEN;

    case PARTNER_AGENT_SIGNUP_TYPE_SUNRISE:
      return PARTNER_SIGNUP_TYPE_SUN_RISE;

    case PARTNER_AGENT_SIGNUP_TYPE_LISTING_AGENT:
    case PARTNER_AGENT_SIGNUP_TYPE_OTHER:
    case null:
      return PARTNER_SIGNUP_TYPE_FULL_SERVICE;

    default:
      return null;
  }
}
